export const getters = {
  isFooterHide: state => {
      return state.footer.hide;
  },
  getFooterState: state => {
      return state.footer;
  }
};
